import { Component } from '@angular/core';
import { LoaderService } from '../service/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  
  isLoaderOn = false;
  constructor(public loaderService: LoaderService){}

  ngOnInit(){
    this.loaderService.isLoaderOn.subscribe((status: boolean) =>{
      this.isLoaderOn = status;
    });
  }
}
